// src/enums/enums.ts
var YotpoSpacing = /* @__PURE__ */ ((YotpoSpacing2) => {
  YotpoSpacing2["none"] = "none";
  YotpoSpacing2["small"] = "small";
  YotpoSpacing2["medium"] = "medium";
  YotpoSpacing2["large"] = "large";
  return YotpoSpacing2;
})(YotpoSpacing || {});
var YotpoPriorityTheme = /* @__PURE__ */ ((YotpoPriorityTheme2) => {
  YotpoPriorityTheme2["lightPrimary"] = "light-primary";
  YotpoPriorityTheme2["lightSecondary"] = "light-secondary";
  YotpoPriorityTheme2["darkPrimary"] = "dark-primary";
  YotpoPriorityTheme2["darkSecondary"] = "dark-secondary";
  return YotpoPriorityTheme2;
})(YotpoPriorityTheme || {});
var YotpoCollapsible = /* @__PURE__ */ ((YotpoCollapsible2) => {
  YotpoCollapsible2["icon"] = "icon";
  YotpoCollapsible2["textAndIcon"] = "text-and-icon";
  YotpoCollapsible2["none"] = "none";
  return YotpoCollapsible2;
})(YotpoCollapsible || {});
var YotpoFooterAction = /* @__PURE__ */ ((YotpoFooterAction2) => {
  YotpoFooterAction2["all"] = "all";
  YotpoFooterAction2["main"] = "main";
  YotpoFooterAction2["none"] = "none";
  return YotpoFooterAction2;
})(YotpoFooterAction || {});
var YotpoGridMargins = /* @__PURE__ */ ((YotpoGridMargins2) => {
  YotpoGridMargins2["none"] = "none";
  YotpoGridMargins2["container"] = "container";
  YotpoGridMargins2["page"] = "page";
  return YotpoGridMargins2;
})(YotpoGridMargins || {});
var YotpoProgressRingStatusIcon = /* @__PURE__ */ ((YotpoProgressRingStatusIcon2) => {
  YotpoProgressRingStatusIcon2["neutral"] = "check";
  YotpoProgressRingStatusIcon2["primary"] = "check";
  YotpoProgressRingStatusIcon2["warning"] = "alert";
  YotpoProgressRingStatusIcon2["danger"] = "alert-circle";
  YotpoProgressRingStatusIcon2["success"] = "check";
  YotpoProgressRingStatusIcon2["premium"] = "check";
  return YotpoProgressRingStatusIcon2;
})(YotpoProgressRingStatusIcon || {});
var YotpoProgressBarStatusIcon = /* @__PURE__ */ ((YotpoProgressBarStatusIcon2) => {
  YotpoProgressBarStatusIcon2["neutral"] = "check-circle";
  YotpoProgressBarStatusIcon2["primary"] = "check-circle";
  YotpoProgressBarStatusIcon2["warning"] = "alert";
  YotpoProgressBarStatusIcon2["danger"] = "alert-circle";
  YotpoProgressBarStatusIcon2["success"] = "check-circle";
  YotpoProgressBarStatusIcon2["premium"] = "check-circle";
  return YotpoProgressBarStatusIcon2;
})(YotpoProgressBarStatusIcon || {});
var YotpoLogoColor = /* @__PURE__ */ ((YotpoLogoColor2) => {
  YotpoLogoColor2["blue"] = "blue";
  YotpoLogoColor2["white"] = "white";
  return YotpoLogoColor2;
})(YotpoLogoColor || {});
var YotpoTableRowSize = /* @__PURE__ */ ((YotpoTableRowSize2) => {
  YotpoTableRowSize2["medium"] = "medium";
  YotpoTableRowSize2["large"] = "large";
  return YotpoTableRowSize2;
})(YotpoTableRowSize || {});
var YotpoColorFormat = /* @__PURE__ */ ((YotpoColorFormat2) => {
  YotpoColorFormat2["hex"] = "hex";
  YotpoColorFormat2["rgb"] = "rgb";
  YotpoColorFormat2["hsl"] = "hsl";
  return YotpoColorFormat2;
})(YotpoColorFormat || {});

export {
  YotpoSpacing,
  YotpoPriorityTheme,
  YotpoCollapsible,
  YotpoFooterAction,
  YotpoGridMargins,
  YotpoProgressRingStatusIcon,
  YotpoProgressBarStatusIcon,
  YotpoLogoColor,
  YotpoTableRowSize,
  YotpoColorFormat
};
